<script>
    // Import general mixin for shared functionality.
    import mixin from './../mixin';
    import constants from './../../constants.js';

    import SourceSet from './SourceSet.vue';

    export default {
        components: { SourceSet },
        mixins: [mixin],
        props: {
            item: {
                type: Object,
                required: true
            },
            mode: {
                type: String,
                default: constants.images.modes.normal
            },
            minLabel: {
                type: String,
                default: constants.labels.story.minutes
            },
            popup: {
                type: Boolean,
                default: false
            },
            tagClass: {
                type: String,
                default: constants.classes.tags.tiffanyBlue
            },
            swiper: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                constants: constants,
            };
        },
        computed: {
            type() {
                return this.item?.type?.[0]?.name ?? null;
            },
            region() {
                return this.item?.regio?.[0]?.name ?? null;
            },
            theme() {
                return this.item?.thema?.[0]?.name ?? null;
            }
        }
    }
</script>

<template>
    <div :class="['column', swiper ? 'swiper-slide' : '', 'is-half-tablet', mode === constants.images.modes.fullwidth || popup ? 'is-full-desktop' : 'is-one-third-desktop']">
        <a :href="item.detailUrl"
           :class="['card', `card--${mode}`, 'is-block', 'is-clipped', 'has-border', mode !== constants.images.modes.normal ? 'has-border-color-transparent' : '']">
            <div v-if="item.image && item.image.length"
                 class="card-image is-clipped">
                <source-set :image-sets="item.image"
                            :mode="popup ? constants.images.modes.normal : mode" />
            </div>
            <div class="card-content has-background-transparent is-flex is-flex-direction-column is-justify-content-flex-end">
                <div v-if="theme"
                     class="tags mb-3">
                    <span :class="['tag', tagClass, 'has-text-weight-semibold']">{{ theme }}</span>
                </div>
                <h3 v-if="item.title"
                    :class="['title', 'mb-4', mode === constants.images.modes.fullwidth ? 'is-4' : 'is-5', mode !== constants.images.modes.normal ? 'has-text-white' : '']">
                    {{ item.title }}
                </h3>
                <div v-if="item.leestijd || region || type"
                     :class="['card-content__metadata', mode !== constants.images.modes.normal ? 'has-text-white' : '']">
                    <span v-if="item.leestijd"
                          class="is-nowrap">
                        <span class="icon mr-1"><i class="fa-solid fa-book-reader"></i></span>
                        <span>{{ item.leestijd }} {{ minLabel }}</span>
                    </span>
                    <span v-else-if="region"
                          class="is-nowrap">
                        <span class="icon mr-1"><i class="fa-solid fa-location-dot"></i></span>
                        <span>{{ region }}</span>
                    </span>
                    <span v-if="(item.leestijd || region) && type">|</span>
                    <span v-if="type">{{ type }}</span>
                </div>
            </div>
        </a>
    </div>
</template>
